import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import LineChart from "../charts/generic/LineChart"

function TemperatureCheckScores({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const tempCheckScoreData = []
  const tempCheckScoreCategories = []

  data.forEach((question, i) => {
    const series = []

    question.results.forEach(entry => {
      //  On the first iteration we want to build the 'Categories' for the chart.
      if (i === 0) {
        const convertedDate = new Date(entry.monthAnswered)
        const shortYear = convertedDate
          .getFullYear()
          .toString()
          .substr(-2)

        tempCheckScoreCategories.push(`${entry.month} ${shortYear}`)
      }

      // Format the data for highchart so its all in a singular list for the 'Series'.
      series.push(entry.averageScaleScore)
    })

    // Add the chart 'Series' data to the chart
    tempCheckScoreData.push({
      name: question.questionText,
      data: series
    })
  })
  const titleKey="Widgets.TemperatureCheckScores.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.TempCheckScore.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <LineChart
        data={tempCheckScoreData}
        categories={tempCheckScoreCategories}
        chartPointStart={0}
        xAxisLabel="Common.Time"
        xTickInterval={1}
        yAxisLabel="Common.Score"
        yTickInterval={1}
        yMinValue={null}
        yMaxValue={10}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

TemperatureCheckScores.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      key: PropTypes.string
    })
  ).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default TemperatureCheckScores



// WEBPACK FOOTER //
// ./src/components/widgets/TemperatureCheckScores.jsx